import { decamelizeKeys } from 'humps';
import { request } from './helper';
import { CHECKR_BFF_API_BASE } from '../constants';

/*
 * Action Types
 */

export const SUBMIT_COMMENT_REQUEST = 'SUBMIT_COMMENT_REQUEST';
export const submitCommentRequestAction = () => ({
  type: SUBMIT_COMMENT_REQUEST,
});
export const SUBMIT_COMMENT_SUCCESS = 'SUBMIT_COMMENT_SUCCESS';
export const submitCommentSuccessAction = () => ({
  type: SUBMIT_COMMENT_SUCCESS,
});

/*
 * Actions
 */

export const submitComment = values => dispatch => {
  dispatch(submitCommentRequestAction());

  const submissionValues = {
    report: values.report,
    comment: values.comment,
    documents: values.documents || [],
  };

  const options = {
    method: 'POST',
    body: JSON.stringify(decamelizeKeys(submissionValues)),
  };

  return request(`${CHECKR_BFF_API_BASE}/comments`, options).then(() =>
    dispatch(submitCommentSuccessAction()),
  );
};
